module.exports = __webpack_public_path__ + "static/media/velma-win.dd97bd8d.png";